const companies = [
  [{ month: '2021-06', drive_count: 1, driving_time: '13238' }],
]
export default {
  get({ values }) {
    if (companies.length < values.companyId) { return [401, {}] }
    return [200, { data: companies[values.companyId] }]
  },
}
